import APIService from '../base'

import type { CommonPagination } from '@/types/common'
import type { ProductInput, ProductItem, ProductQuery } from '@/types/product'
import type { AxiosResponse } from 'axios'

export class ProductService {
  static getList(
    query: ProductQuery,
  ): Promise<AxiosResponse<CommonPagination<ProductItem>>> {
    return APIService.get('/v1/products', { params: query })
  }

  static create(body: ProductInput[]): Promise<void> {
    return APIService.post('/v1/products/bulk', body)
  }

  static update(id: string, body: Partial<ProductInput>): Promise<void> {
    return APIService.patch(`/v1/products/${id}`, body)
  }

  static delete(id: string): Promise<void> {
    return APIService.delete(`/v1/products/bulk`, { data: { ids: [id] } })
  }

  static getDetail(id: string): Promise<AxiosResponse<ProductItem>> {
    return APIService.get(`/v1/products/${id}`)
  }
}
